import http from '@/utils/http'
import {getToken, removeToken, removeCookiePubKey, getSign} from '@/utils/auth'
import constant from '@/utils/constant' 

export function getUserMenus() {
  let params = {
    'where': {},
    'page': '[0, 9999999999]',
    'sort': {}
  }
  return http.get('/api/sys/menu', JSON.stringify(params));
}

export function heart() {
  const data = {};
  return http.put('/api/sys/login/heartbeat', JSON.stringify(data));
}

export function otpCode(gcode) {
  const data = {'gcode': gcode};
  return http.post('/api/sys/login/otpcode', JSON.stringify(data));
}

export function otpCodeSend(mode) {
  const data = {'mode': mode};
  return http.post('/api/sys/login/otpcode/send', JSON.stringify(data));
}

/* 检查登录sid */
export function checkLoginSid() {
  const token = getToken();
  if (token) {
    const data = {
      sid: token
    };
    return http.post('/api/sys/login/islogged', JSON.stringify(data));
  } else {
    return new Promise(function (resolve, reject) {
      reject(new Error({'error': constant.ERROR_NOT_LOGGED}))
    })
  }
}

/* 获取RSA公钥 */
export function getPubKey() {
  const data = {};
  return http.get('/api/sys/login/pubkey', JSON.stringify(data));
}

/* 登录图片验证码网址 */
export function getVerifyCodeUrl(username) {
  const imageUrl = '/api/sys/captcha?username=' + encodeURIComponent(username);
  return new Promise(function (resolve, reject) {
    resolve(imageUrl)
  });
}

/* 是否需要登录图片验证码 */
export function needCheck(username) {
  const data = {username: username};
  return http.post('/api/sys/user/need-check', JSON.stringify(data));
}

/* 登录 */
export function loginByUsername(username, password, pubkey, verifycode) {
  // const rsapassword = crypto(password);
  // if (rsapassword == '') {
  //   return new Promise(function (resolve, reject) {
  //     reject('未获取到公钥')
  //   });
  // } 
  const data = {
    username: username,
    password: password,
    verify: verifycode,
    type: 1,
  }
  return http.post('/api/sys/user/login', JSON.stringify(data));
}

export function logout() {
  const data = {}; 
  removeToken();
  removeCookiePubKey();
  return new Promise(function (resolve, reject) {
    resolve()
  });
}

export function getUserInfo(token) {
  return http({
    url: '/api/sys/user/info',
    method: 'get',
    params: {token}
  })
}

export function getUserAuth() {
  return http({
    url: '/wallet_client/query/merchant/info',
    method: 'get',
    params: {where: {}, page: '[0, 1]'}
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js